import { t } from '@/plugins/i18n'
import { nextTick, ref, toRaw } from 'vue'
import { productDetail } from '@/apis/search'

const formatCommonProductSku = (data: any, rate: number) => {
  const productName = data.productTitle
  const platformType = data.platformType
  return (data.skuList || []).map((v: any) => ({
    ...v,
    id: v.productSku,
    code: v.productCode,
    name: productName,
    type: platformType,
    img: v.productSkuImg || data.productMainImg,
    PropertiesName: v.productPropertiesName,
    price: v.productSellPrice ?? 0,
    PriceJpy: (v.productSellPrice ?? 0) * rate ? Math.floor((v.productSellPrice ?? 0) * rate) : 0,
    productCategoryFrontendFirstNameJp: data.productCategoryFrontendFirstNameJp,
    productCategoryFrontendSecondNameJp: data.productCategoryFrontendSecondNameJp
  }))
}

export default (productCode: any, rate: any, emits: any) => {
  const list: any = ref([])
  const loading: any = ref(false)
  const getList = async () => {
    loading.value = true
    emits('update:skuLoading', true)
    try {
      await cb()
      loading.value = false
      emits('update:skuLoading', false)
    } catch (error) {
      loading.value = false
      emits('update:skuLoading', false)
    }
  }

  const cb = async (type?:boolean) => {
    const res: any = await promise(type)
    if (res.success) {
      if (res.data?.skuList.length) {
        list.value = formatCommonProductSku(res.data, rate.value)
        nextTick(() => {
          emits('update:skuList', list.value)
        })
      } else {
        const bool = true
        await cb(bool)
      }
    }
  }
  const promise = (type?:boolean) => {
    return new Promise((resolve) => {
      const fn = () => {
        productDetail({ productCode: productCode.value }).then(res => {
          resolve(res)
        })
      }
      type ? setTimeout(fn, 500) : fn()
    })
  }

  return [
    loading,
    list,
    getList
  ]
}
